import { FetchError } from 'sevenshifts-api';

/**
 * Detects client-side network/offline failures (e.g. device sleep/wake, dropped
 * connection, captive portal) as opposed to genuine, actionable application
 * errors.
 *
 * The generated API runtime (`sevenshifts-api-ts/src/runtime.ts`) throws
 * `FetchError` only when the underlying `fetch` itself rejects — i.e. the
 * request never reached the server. Non-2xx HTTP responses are surfaced as
 * `ResponseError`, not `FetchError`, so a `FetchError` always represents a
 * network-level failure and this check is precise.
 *
 * The `name` fallback keeps the check reliable across module/bundle boundaries
 * (e.g. inside Sentry's `beforeSend`) where `instanceof` can be unreliable if
 * more than one copy of the generated client is bundled.
 */
export const isNetworkError = (e: unknown): boolean =>
    e instanceof FetchError ||
    (typeof e === 'object' && e !== null && (e as Error).name === 'FetchError');
